const ANALYTICS_BASE = 'https://analytics.elitepokerlounge.com';

const buildAnalyticsUrl = (endpoint, { startDate, endDate }) => {
  const url = `${ANALYTICS_BASE}/${endpoint}?startdate=${startDate}`;
  if (!endDate || endDate === startDate) return url;
  return `${url}&enddate=${endDate}`;
};

export const fetchAnalyticsData = async ({ startDate, endDate, isSingleDay }) => {
  const url = buildAnalyticsUrl('fetch-data-brownsville', { startDate, endDate, isSingleDay });

  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('Failed to fetch analytics data');
  }

  return response.json();
};
